module.exports = __webpack_public_path__ + "808d65a0fe7b7fdcf2cbefe7b3068257.svg";